import Region from "../Region";
import RegionArea from "../RegionArea";
import Phaser from 'phaser';

import * as ABCya from '@abcya/abcya_phaser';
import UIAssetKeys from '../UIAssetKeys';
import { AREAS, REGIONS, SHAPES } from '../gameData';

export default class GreenBuildingArea extends RegionArea
{
    /**
     * Create the green building area.
     * @param {Region} region the owner region
     */
    constructor(parentRegion)
    {
        super(parentRegion, AREAS[REGIONS.DOWNTOWN].GREEN_BUILDING);

        this._createArea();

        this.reset();
    }

    /**
     * Reset should be called when you want to set the state to a disabled/inactive state.
     */
    reset()
    {
        super.reset();

        this.ledge.setAlpha(0);
        this.ledgeFront.setAlpha(0);
        this.roofLarge.setAlpha(0);
        this.roofSmall.setAlpha(0);
        this.wall1.setAlpha(0);
        this.window0.setAlpha(0);
        this.window1.setAlpha(0);
        this.window2.setAlpha(0);
        this.window3.setAlpha(0);
    }

    /**
     * Prepare should be called before you want to prepare the state to become active.
     */
    prepare()
    {
        super.prepare();

        this.ledge.disableInteractive();
        this.ledgeFront.disableInteractive();
        this.roofLarge.disableInteractive();
        this.roofSmall.disableInteractive();
        this.wall1.disableInteractive();
        this.window0.disableInteractive();
        this.window1.disableInteractive();
        this.window2.disableInteractive();
        this.window3.disableInteractive();
    }

    /**
     * Send all game objects to their start positions.
     */
    _sendObjectsToStartPositions()
    {
        super._sendObjectsToStartPositions();

        this.ledge.setAlpha(0.000001);
        this.ledgeFront.setAlpha(0.000001);
        this.roofLarge.setAlpha(0.000001);
        this.roofSmall.setAlpha(0.000001);
        this.wall1.setAlpha(0.000001);
        this.window0.setAlpha(0.000001);
        this.window1.setAlpha(0.000001);
        this.window2.setAlpha(0.000001);
        this.window3.setAlpha(0.000001);
    }

    /**
     * Creates the area, by adding the overlays to the parent region and creates the area information sidebar.
     */
    _createArea()
    {
        let ledgeHitArea = new Phaser.Geom.Polygon(
            [
                { x: 218, y: 141 },
                { x: 0, y: 13 },
                { x: 20, y: 0 },
                { x: 238, y: 127 },
            ]);
        this.ledge = ABCya.Images.addImage(599, 262, UIAssetKeys._08_Downtown_Zoom_In_Green_Building_Slct_Ldge, this.parentRegion).setInteractive(ledgeHitArea, Phaser.Geom.Polygon.Contains);
        this.ledge.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.ledge, SHAPES.RECTANGLE);
        });

        let ledgeFrontHitArea = new Phaser.Geom.Polygon(
            [
                { x: 221, y: 157 },
                { x: 0, y: 31 },
                { x: 0, y: 0 },
                { x: 221, y: 126 },
            ]);
        this.ledgeFront = ABCya.Images.addImage(607, 243, UIAssetKeys._08_Downtown_Zoom_In_Green_Building_Slct_Rctngl, this.parentRegion).setInteractive(ledgeFrontHitArea, Phaser.Geom.Polygon.Contains);
        this.ledgeFront.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.ledgeFront, SHAPES.RECTANGLE);
        });

        let roofLargeHitArea = new Phaser.Geom.Polygon(
            [
                { x: 218, y: 255 },
                { x: 0, y: 128 },
                { x: 218, y: 0 },
                { x: 436, y: 128 },
            ]);
        this.roofLarge = ABCya.Images.addImage(715, 169, UIAssetKeys._08_Downtown_Zoom_In_Green_Building_Slct_RfLg, this.parentRegion).setInteractive(roofLargeHitArea, Phaser.Geom.Polygon.Contains);
        this.roofLarge.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.roofLarge, SHAPES.SQUARE);
        });

        let roofSmallHitArea = new Phaser.Geom.Polygon(
            [
                { x: 156, y: 182 },
                { x: 0, y: 91 },
                { x: 156, y: 0 },
                { x: 311, y: 91 },
            ]);
        this.roofSmall = ABCya.Images.addImage(715, 180, UIAssetKeys._08_Downtown_Zoom_In_Green_Building_Slct_RfSm, this.parentRegion).setInteractive(roofSmallHitArea, Phaser.Geom.Polygon.Contains);
        this.roofSmall.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.roofSmall, SHAPES.SQUARE);
        });

        let wall1HitArea = new Phaser.Geom.Polygon(
            [
                { x: 0, y: 553 },
                { x: 0, y: 125 },
                { x: 222, y: 0 },
                { x: 222, y: 428 },
            ]);
        this.wall1 = ABCya.Images.addImage(822, 442, UIAssetKeys._08_Downtown_Zoom_In_Green_Building_Slct_Wall_1, this.parentRegion).setInteractive(wall1HitArea, Phaser.Geom.Polygon.Contains);
        this.wall1.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.wall1, SHAPES.RECTANGLE);
        });

        let windowHitArea = new Phaser.Geom.Polygon(
            [
                { x: 0, y: 131 },
                { x: 0, y: 26 },
                { x: 50, y: 0 },
                { x: 50, y: 105 },
            ]);
        this.window0 = ABCya.Images.addImage(778, 381, UIAssetKeys._08_Downtown_Zoom_In_Green_Building_Slct_Wndw_1, this.parentRegion).setInteractive(windowHitArea, Phaser.Geom.Polygon.Contains);
        this.window0.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.window0, SHAPES.RECTANGLE);
        });

        this.window1 = ABCya.Images.addImage(779, 579, UIAssetKeys._08_Downtown_Zoom_In_Green_Building_Slct_Wndw_1, this.parentRegion).setInteractive(windowHitArea, Phaser.Geom.Polygon.Contains);
        this.window1.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.window1, SHAPES.RECTANGLE);
        });

        this.window2 = ABCya.Images.addImage(864, 330, UIAssetKeys._08_Downtown_Zoom_In_Green_Building_Slct_Wndw_1, this.parentRegion).setInteractive(windowHitArea, Phaser.Geom.Polygon.Contains);
        this.window2.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.window2, SHAPES.RECTANGLE);
        });

        this.window3 = ABCya.Images.addImage(865, 528, UIAssetKeys._08_Downtown_Zoom_In_Green_Building_Slct_Wndw_1, this.parentRegion).setInteractive(windowHitArea, Phaser.Geom.Polygon.Contains);
        this.window3.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.window3, SHAPES.RECTANGLE);
        });

        this.shapeOverlays[SHAPES.SQUARE] = [this.roofLarge, this.roofSmall];
        this.shapeOverlays[SHAPES.RECTANGLE] = [this.ledge, this.ledgeFront, this.wall1, this.window0, this.window1, this.window2, this.window3];

        this._createAreaInformation(0x5f5fd6, 0x2b4270);
    }

    /**
     * Zoom into the area.
     */
    zoomIn()
    {
        let tweens = super.zoomIn();

        tweens.push(
            {
                targets: [
                    this.parentRegion.blueBuilding, this.parentRegion.treeAndBenchContainer, this.parentRegion.peachBuilding
                ],
                duration: 500,
                props: { alpha: 0 },
                ease: Phaser.Math.Easing.Quadratic.Out,
            },
            { targets: this.parentRegion.greenBuilding, duration: 1000, props: { scale: 1, x: 691, y: 381 }, ease: Phaser.Math.Easing.Quadratic.Out, offset: 0 },
            { targets: this.areaInformation, duration: 500, props: { x: this.areaInformation.onScreenPosition.x }, ease: Phaser.Math.Easing.Back.Out, offset: 500 }
        );

        return tweens;
    }

    /**
     * Zoom out of the area.
     */
    zoomOut()
    {
        let tweens = super.zoomOut();

        this.ledge.disableInteractive();
        this.ledgeFront.disableInteractive();
        this.roofLarge.disableInteractive();
        this.roofSmall.disableInteractive();
        this.wall1.disableInteractive();
        this.window0.disableInteractive();
        this.window1.disableInteractive();
        this.window2.disableInteractive();
        this.window3.disableInteractive();

        for (let shape in this.shapeOverlays)
        {
            // fade off the overlay
            tweens.push(
                {
                    targets: this.shapeOverlays[shape],
                    duration: 500,
                    props: { alpha: 0 },
                    ease: Phaser.Math.Easing.Quadratic.Out,
                    offset: 0
                }
            );
        }

        tweens.push(
            { targets: this.areaInformation, duration: 500, props: { x: this.areaInformation.offScreenPosition.x }, ease: Phaser.Math.Easing.Back.In, offset: 0 },
            { targets: this.parentRegion.greenBuilding, duration: 1000, props: { scale: .6329, x: this.parentRegion.greenBuilding.onScreenPosition.x, y: this.parentRegion.greenBuilding.onScreenPosition.y }, ease: Phaser.Math.Easing.Quadratic.Out, offset: 250 },
            { targets: [this.parentRegion.blueBuilding, this.parentRegion.treeAndBenchContainer, this.parentRegion.peachBuilding], duration: 500, props: { alpha: 1 }, ease: Phaser.Math.Easing.Quadratic.Out, offset: 500 },
        );

        return tweens;
    }
}